export const MAPCONTROL_NAME = "FeatureInfo";